



















































import {Component, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CTextField from '@/components/base/textField/CTextField.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
@Component({
    components: {CEditDialog, CCheckbox, CSelect, CTextField},
})
export default class AdminUserEditDialog extends Mixins(EditDialogMixin) {
    public errorKeyList = {
        UserName: 'UserName',
        IdCompany: 'IdCompany',
        Email: 'Email',
        FullName: 'FullName',
    };
    get emailRules() {
        return [
            (v: any) =>
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                    v,
                ) || this.$t('Systems.User.EmailErrMsg'),
        ];
    }
}
